/* Legend eBikes · buscador del Centro de Ayuda
   Carga el índice del idioma activo y filtra las 73 preguntas en cliente.
   Los textos visibles llegan por data-attributes desde la sección,
   para que Translate & Adapt pueda traducirlos. */

(function () {
  var raiz = document.querySelector('.lfaq');
  if (!raiz) return;

  var loc = (raiz.dataset.locale || 'es').toLowerCase().split('-')[0];
  var base = raiz.dataset.cdn || '';
  // Sufijo para saltarse la cache del CDN al actualizar los indices.
  // Se cambia desde el ajuste "Version del indice" de la seccion.
  var ver = (raiz.dataset.ver || '').trim();
  var sufijo = ver ? ('?v=' + encodeURIComponent(ver)) : '';
  var TXT = {
    uno: raiz.dataset.txtUno || 'result',
    varios: raiz.dataset.txtVarios || 'results',
    sin: raiz.dataset.txtSin || 'No results for',
    prueba: raiz.dataset.txtPrueba || 'Try different words.'
  };

  var q = document.getElementById('lfaqQ'),
      x = document.getElementById('lfaqX'),
      res = document.getElementById('lfaqRes'),
      resN = document.getElementById('lfaqResN'),
      lista = document.getElementById('lfaqList'),
      cats = document.getElementById('lfaqCats');

  if (!q) return;

  var IDX = [];
  var VACIAS = {
    de:1, la:1, el:1, en:1, y:1, a:1, los:1, las:1, un:1, una:1, para:1,
    con:1, que:1, del:1, al:1, mi:1, se:1, es:1, por:1, como:1, cuanto:1,
    cual:1, donde:1,
    the:1, of:1, to:1, my:1, is:1, how:1, what:1, and:1, for:1,
    le:1, les:1, des:1, est:1, mon:1, comment:1, pour:1,
    der:1, die:1, das:1, ist:1, wie:1, mein:1, und:1,
    het:1, een:1, van:1, hoe:1, mijn:1,
    il:1, lo:1, che:1, come:1, per:1,
    o:1, as:1, do:1, da:1, meu:1,
    els:1, amb:1, per:1, que:1, meva:1, meu_ca:1, com:1,
    jak:1, czy:1, moj:1, moja:1, jest:1, sie:1, nie:1, dla:1, oraz:1
  };

  function cargar(idioma, alFallar) {
    fetch(base + 'faq-index-' + idioma + '.json' + sufijo)
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) { IDX = d; })
      .catch(function () { if (alFallar) alFallar(); });
  }

  cargar(loc, function () {
    if (loc !== 'en') cargar('en');
  });

  function norm(s) {
    return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function terminos(v) {
    return norm(v).split(/\s+/).filter(function (t) {
      return t.length > 2 && !VACIAS[t];
    });
  }

  function esc(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function escHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function marcar(txt, ts) {
    var out = escHtml(txt);
    ts.forEach(function (t) {
      out = out.replace(new RegExp('(' + esc(t) + ')', 'gi'), '<mark>$1</mark>');
    });
    return out;
  }

  function pintar() {
    var v = q.value.trim();
    x.classList.toggle('on', v.length > 0);

    if (v.length < 2) {
      res.hidden = true;
      cats.hidden = false;
      return;
    }

    var ts = terminos(v);
    if (!ts.length) {
      res.hidden = true;
      cats.hidden = false;
      return;
    }

    var hits = IDX.map(function (a) {
      var t = norm(a.t),
          xx = norm(a.x || ''),
          c = norm(a.c || ''),
          p = 0;
      ts.forEach(function (term) {
        if (t.indexOf(term) === 0) p += 12;
        else if (t.indexOf(term) > -1) p += 9;
        if (xx.indexOf(term) > -1) p += 3;
        if (c.indexOf(term) > -1) p += 2;
      });
      return { a: a, p: p };
    }).filter(function (r) {
      return r.p > 0;
    }).sort(function (m, n) {
      return n.p - m.p;
    }).slice(0, 12);

    res.hidden = false;
    cats.hidden = true;

    if (!hits.length) {
      resN.textContent = '';
      lista.innerHTML = '<div class="lfaq__none"><strong>' +
        escHtml(TXT.sin) + ' "' + escHtml(v) + '"</strong>' +
        escHtml(TXT.prueba) + '</div>';
      return;
    }

    resN.textContent = hits.length + ' ' + (hits.length === 1 ? TXT.uno : TXT.varios);

    lista.innerHTML = hits.map(function (h) {
      var a = h.a;
      return '<a class="lfaq__hit" href="' + a.u + '">' +
        '<b>' + escHtml(a.c) + '</b>' +
        '<h3>' + marcar(a.t, ts) + '</h3>' +
        (a.x ? '<p>' + marcar(a.x, ts) + '</p>' : '') +
        '</a>';
    }).join('');
  }

  q.addEventListener('input', pintar);
  x.addEventListener('click', function () {
    q.value = '';
    q.focus();
    pintar();
  });
})();